export interface ParsedPowerBiLink {
  groupId: string;
  reportId: string;
  embedUrl: string;
}

const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Aceita o link copiado do navegador
// (app.powerbi.com/groups/<workspace>/reports/<relatório>/...) ou a URL de
// embed (app.powerbi.com/reportEmbed?reportId=...&groupId=...). Devolve null
// quando não reconhece o link.
export function parsePowerBiLink(link: string): ParsedPowerBiLink | null {
  let url: URL;

  try {
    url = new URL(link.trim());
  } catch {
    return null;
  }

  if (!/(^|\.)powerbi\.com$/i.test(url.hostname)) {
    return null;
  }

  if (/\/reportEmbed$/i.test(url.pathname)) {
    const reportId = url.searchParams.get('reportId') || '';
    const groupId = url.searchParams.get('groupId') || '';

    if (!GUID.test(reportId) || !GUID.test(groupId)) {
      return null;
    }

    return { groupId, reportId, embedUrl: url.toString() };
  }

  const match = url.pathname.match(/\/groups\/([^/]+)\/reports\/([^/]+)/i);

  if (!match || !GUID.test(match[1]) || !GUID.test(match[2])) {
    return null;
  }

  const [, groupId, reportId] = match;

  return {
    groupId,
    reportId,
    embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=${groupId}`,
  };
}
